module.exports = __webpack_public_path__ + "static/img/bg-tr.66d877e7.png";